<span *ngIf="data" class="badge me-1" [ngClass]="'text-bg-'+theme" [popover]="popTemplate" html="true"
  placement="bottom" triggers="mouseenter:mouseleave" container="body">{{tag}} <i class="fas fa-info-circle"></i></span>
<ng-template #popTemplate>
  <table class="table table-sm table-bordered table-striped">
    <tbody>
    @for (item of data; track item) {
    <tr>
      <td>{{item}}</td>
    </tr>
    }
    </tbody>
  </table>
</ng-template>
<span *ngIf="!data" class="badge me-1" [ngClass]="'text-bg-'+theme">{{tag}}</span>